import { tooltipPriorityMap } from "../services/constants";
import useTooltipStore from "../zustandStores/TooltipStore";
function addToolTipToStore(obj) {
  const { setCurrentTooltipList } = useTooltipStore.getState();
  setCurrentTooltipList(obj);
}

function removeToolTipFromStore(obj) {
  const { deleteFromTooltipList, deleteFromObservedTooltip } =
    useTooltipStore.getState();
  deleteFromTooltipList(obj.id);
  deleteFromObservedTooltip(obj.id);
}
function resetTooltipStore() {
  const { resetStore } = useTooltipStore.getState();
  resetStore();
}
function getToolTipPriority(key) {
  return tooltipPriorityMap[key];
}

export {
  addToolTipToStore,
  removeToolTipFromStore,
  getToolTipPriority,
  resetTooltipStore
};
